import { MenuListItem, MenuListItemIcon } from "components/ui/MenuList";
import { notification } from "components/ui-deprecated";
import { useAppSelector } from "store";

/**
 * Menu item for copying the authentication token to clipboard.
 * Only visible in developer mode and when a token is present.
 */
export const CopyAuthTokenMenuItem = () => {
    const accessToken = useAppSelector((state) => state.auth.accessToken);
    const developerMode = useAppSelector((state) => state.user.developerMode);

    if (!developerMode || !accessToken) return null;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(accessToken);
            notification.success("Authentication token copied to clipboard");
        } catch {
            notification.warning("Failed to copy authentication token");
        }
    };

    return (
        <MenuListItem onClick={handleCopy}>
            <MenuListItemIcon icon="lely-icon-copy" />
            Copy Authentication Token
        </MenuListItem>
    );
};
